import { cn } from '@/util/cn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('$tw-animate-pulse $tw-rounded-md $tw-bg-muted/50', className)} {...props} />
  );
}

export { Skeleton };
